import { useEffect } from 'react'

let hasInitialized = false
const useSetupMatomo = () => {
  useEffect(() => {
    const containerID = import.meta.env.VITE_MATOMO_CONTAINER_ID
    const matomoUrl = import.meta.env.VITE_MATOMO_URL || 'https://qstar-matomo.hemsida.eu'
    if (!hasInitialized && containerID) {
      // @ts-ignore
      // eslint-disable-next-line no-multi-assign
      const _mtm = (window._mtm = window._mtm || [])
      _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })
      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]
      g.async = true

      g.src = `${matomoUrl}/js/container_${containerID}.js`
      s.parentNode?.insertBefore(g, s)
      hasInitialized = true
    }
  }, [])
  return null
}

export default useSetupMatomo
